import React from "react";
import "../page.css";






const Gallery = (props) =>{
    return(
        <div class="row">
        
                <div id="gt-1"class="col-md-12 col-lg-6">
                    
                </div>
                <div id="gt-2"class="col-md-12 col-lg-6">
                    
                </div>
                <div id="gt-3"class="col-md-12 col-lg-6">
                    
                </div>
                <div id="gt-4"class="col-md-12 col-lg-6">
                    
                </div>

    </div>
    )
}


export default Gallery;